import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

/**
 * Note: sub-menu only appear when route children.length >= 1
 *
 * meta: {
    key: 'key'                    the key used to translate label
    label: 'label'                the name show in sidebar and breadcrumb
    keepAlive: [true, false]      keep this item's state
    icon: 'icon'                  the icon show in the sidebar
    roles: [xxx]                  this item will only show to roles: system/root/user
  }
 */
export const defaultRoutes = [
  // main routes.
  {
    path: '/page404',
    component: () => import('@/views/Page404')
  },
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    component: () => import('@/views/Home')
  },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/page404' }
]

const createRouter = () => {
  const routes = defaultRoutes
  return new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes,
    scrollBehavior: () => ({ y: 0 })
  })
}

const router = createRouter()

router.beforeEach((to, from, next) => {
  next()
})

router.afterEach((to, from) => {})

/* reset router */
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // the relevant part
}

export default router
